import React from "react";

const Title = ({ bg, bgSize, bgRepeat, bgPos, children }) => {
    return (
        <div
            className="title"
            style={{
                backgroundImage: "url(" + bg + ")",
                backgroundSize: bgSize,
                backgroundRepeat: bgRepeat,
                backgroundPosition: bgPos,
            }}
        >
            <h1>
                {children}
                <br />-
            </h1>
        </div>
    );
};

export default Title;
